<template>
  <div class="home">
    <van-nav-bar
      :title="$t('SetMenu.title')"
      :fixed="true"
      left-arrow
      clickable="false"
      @click-left="$router.push('/ShopSet/' + sessionStorage.actShopId)"
      @click.prevent=""
    >
      <template slot="right">
        <van-button
          class="rightBtn"
          style="margin-right: 10px;"
          color="#1989fa"
          @click="addShow()"
        >
          {{ $t("ShopList.add") }}
        </van-button>
        <van-button class="rightBtn" color="#ee0a24" @click="delShow()">
          {{ $t("ShopList.delete") }}
        </van-button>
      </template>
    </van-nav-bar>

    <div class="van-tabs">
      <van-tabs
        v-model="actTab"
        sticky
        :lazy-render="true"
        :offset-top="46"
        :swipe-threshold="5"
        @change="tabChange"
        @click="goDish"
      >
        <van-tab
          v-for="(item, index) in contentList"
          :key="index"
          :title="item.name"
        >
          <!-- 搜索栏 -->
          <van-search
            v-model="searchMenu"
            :clearable="false"
            :placeholder="contentList[index].placeholder"
            @search="onSearch"
            @input="onSearch"
          >
          </van-search>
          <!-- 批量绑定分类 -->
          <div class="function" v-if="index == 2">
            <div v-if="functionShow == 'none'">
              <van-button type="info" @click="functionShow = 'block'">
                {{ $t("SetMenu.batch") }}
              </van-button>
            </div>
            <div class="flexBox" v-else-if="functionShow == 'block'">
              <el-dropdown split-button type="primary" @command="changeCompany">
                {{ $t("SetMenu.Selected") }} {{ tabsResult.length }}
                {{ $t("SetMenu.term") }}
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="class">
                    {{ $t("SetMenu.batchClass") }}
                  </el-dropdown-item>
                  <el-dropdown-item command="perfer">
                    {{ $t("SetMenu.batchPerfer") }}
                  </el-dropdown-item>
                  <el-dropdown-item command="price">
                    {{ $t("SetMenu.batchPrice") }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <van-button color="#FF9900" @click="backBtn">
                {{ $t("vantText.cancel") }}
              </van-button>
            </div>
          </div>
          <!-- 选项名称 -->
          <div class="title">
            <div class="left-name mleft">
              <span>{{ $t("SetMenu.show") }}</span>
              <span class="mleft">{{ $t("SetMenu.name") }}</span>
            </div>
            <div class="right-name">
              <span class="swtichName" v-if="actTab == 0">{{
                $t("SetMenu.showSwitch")
              }}</span>
              <span class="swtichName" v-else-if="actTab == 1">{{
                $t("SetMenu.perferSwitch")
              }}</span>
              <span class="edit">{{ $t("SetMenu.edit") }}</span>
            </div>
          </div>
          <van-loading v-if="loading" color="#1989fa" type="spinner" />
          <!-- 复选框 -->
          <van-checkbox-group
            v-if="item.placeholder != ''"
            v-model="tabsResult"
            @change="tabsChange"
          >
            <draggable
              v-model="content"
              handle=".dragIcon"
              chosen-class="chosen"
              force-fallback="true"
              group="people"
              @start.stop="onStart"
              @end.stop="onEnd"
              :move="onMove"
            >
              <transition-group
                class="transition-wrapper"
                :name="drag ? 'sort' : ''"
              >
                <van-field
                  v-for="(tab, index) in content"
                  :key="tab.id"
                  v-model="tab.name"
                  :readonly="isCheckboxesShow == 'none' ? false : true"
                  @click="isCheckboxesShow == 'none' ? '' : toggle(index)"
                  @focus="isCheckboxesShow == 'none' ? showBtn(index) : ''"
                  @blur="
                    isCheckboxesShow == 'none' ? hideBtn(index) : '';
                    handBtn(index);
                  "
                  :placeholder="item.placeholder"
                >
                  <template #left-icon>
                    <van-checkbox
                      v-if="
                        isCheckboxesShow == 'block' || functionShow == 'block'
                      "
                      :style="
                        isCheckboxesShow == 'block'
                          ? {
                              display: isCheckboxesShow
                            }
                          : { display: functionShow }
                      "
                      :name="tab.id"
                      ref="checkboxes"
                      slot="left-icon"
                    >
                      <img
                        style="width: 20px; height: 20px"
                        slot="icon"
                        slot-scope="props"
                        :src="
                          props.checked
                            ? './static/img/sele.png'
                            : './static/img/unsele.png'
                        "
                      />
                    </van-checkbox>
                    <van-icon
                      v-else
                      name="./static/img/drag.png"
                      class="dragIcon"
                      @click="dragToast(actTab)"
                    />
                  </template>
                  <template #right-icon>
                    <van-switch
                      v-if="actTab == 0"
                      size="30"
                      style="margin-top:5px"
                      v-model="tab.status"
                      @click="Switch(tab)"
                      active-color="#2f75f7"
                      inactive-color="#ee0a24"
                    />
                    <van-switch
                      v-else-if="actTab == 1"
                      size="30"
                      style="margin-top:5px"
                      v-model="tab.is_choiced"
                      @click="Switch(tab)"
                      active-color="#2f75f7"
                      inactive-color="#ee0a24"
                    />
                    <van-button
                      class="editBtn"
                      color="#1989fa"
                      @click.stop="editBtn(tab)"
                      >{{ $t("ShopList.edit") }}</van-button
                    >
                    <van-button
                      style="margin-left: 0.625rem"
                      class="editBtn"
                      color="#ff6600"
                      @click.stop="copyBtn(tab)"
                      >{{ $t("ShopList.copy") }}</van-button
                    >
                  </template>
                </van-field>
              </transition-group>
            </draggable>
          </van-checkbox-group>
        </van-tab>
      </van-tabs>
    </div>
    <van-tabbar v-if="isCheckboxesShow == 'block' || functionShow == 'block'">
      <div style="width: 100%; height: 50px">
        <div class="bottomBtn fl">
          <van-icon
            size="30px"
            @click="selectAll()"
            name="./static/img/all.png"
          />
        </div>
        <div class="bottomBtn fr" v-if="isCheckboxesShow == 'block'">
          <van-icon
            size="30px"
            @click="del()"
            name="./static/img/Trash_s.png"
          />
        </div>
        <div class="functionBtn fr" v-else-if="functionShow == 'block'">
          <!-- <van-button type="info" @click="okBtn">确认</van-button> -->
          <!-- <van-button color="#FF9900" @click="backBtn">
            取消
          </van-button> -->
        </div>
      </div>
    </van-tabbar>
    <van-popup v-model="show" round>
      <div class="functionBox" v-if="batchType == 'class'">
        <h3>{{ $t("SetMenu.batchClassTitle") }}</h3>
        <div class="mbottom">{{ $t("SetMenu.category") }}：</div>
        <van-checkbox-group v-model="tagResult">
          <span v-for="(item, key) in tags" :key="key">
            <van-checkbox :name="item.id" ref="checkboxes">
              <img
                style="width: 20px; height: 20px"
                slot="icon"
                slot-scope="props"
                :src="
                  props.checked
                    ? './static/img/sele.png'
                    : './static/img/unsele.png'
                "
            /></van-checkbox>
            {{ item.name }}
          </span>
        </van-checkbox-group>
        <div class="functionFooter">
          <van-button type="default" @click="show = false">
            {{ $t("vantText.cancel") }}
          </van-button>
          <van-button type="info" @click="okBtn(1)">
            {{ $t("vantText.confirm") }}
          </van-button>
        </div>
      </div>
      <div class="functionBox" v-if="batchType == 'perfer'">
        <h3>{{ $t("SetMenu.batchPerferTitle") }}</h3>
        <div class="mbottom">{{ $t("SetMenu.prefer") }}：</div>
        <van-checkbox-group v-model="perResult">
          <span v-for="(item, key) in perfers" :key="key">
            <van-checkbox :name="item.id" ref="checkboxes">
              <img
                style="width: 20px; height: 20px"
                slot="icon"
                slot-scope="props"
                :src="
                  props.checked
                    ? './static/img/sele.png'
                    : './static/img/unsele.png'
                "
            /></van-checkbox>
            {{ item.name }}
          </span>
        </van-checkbox-group>
        <div class="functionFooter">
          <van-button type="default" @click="show = false">
            {{ $t("vantText.cancel") }}
          </van-button>
          <van-button type="info" @click="okBtn(2)">
            {{ $t("vantText.confirm") }}
          </van-button>
        </div>
      </div>
      <div class="functionBox" v-if="batchType == 'price'">
        <h3>{{ $t("SetMenu.batchPriceTitle") }}</h3>
        <van-field
          v-model="batchPrice"
          type="number"
          :label="$t('SetMenu.price')"
        />
        <div class="functionFooter">
          <van-button type="default" @click="show = false">
            {{ $t("vantText.cancel") }}
          </van-button>
          <van-button type="info" @click="editAmount">
            {{ $t("vantText.confirm") }}
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  data() {
    return {
      actTab: 0,
      content: [],
      contentList: [],
      tags: [], // 分类
      perfers: [], // 偏好
      dishs: [], // 产品
      packages: [], // 套餐
      tabsResult: [],
      tagsResult: [],
      perferResult: [],
      dishsResult: [],
      packagesResult: [],

      newTag: {
        name: ""
      },
      newPerfer: {
        name: ""
      },
      newDish: {
        name: ""
      },
      newPack: {
        name: ""
      },
      tagResult: [],
      perResult: [],
      actTagBtn: -1,
      actPerferBtn: -1,
      actDishBtn: -1,
      actPackBtn: -1,

      isCheckboxesShow: "none",
      functionShow: "none",
      saveContent: false,
      timer: null,

      searchMenu: "", //当前输入的搜索文本
      searchMenuList: "", //临时存储输入所有搜索文本
      checked: true,
      status: 0,
      data: null,
      drag: false,
      startItem: {},
      endItem: {},
      loading: false, // 加载中
      batchType: "",
      batchPrice: 0,
      show: false,
      PopName: "",
      timer: null
    };
  },
  created() {
    this.contentList = [
      {
        name: this.$t("SetMenu.category"),
        placeholder: this.$t("SetMenu.inputCategory")
      },
      {
        name: this.$t("SetMenu.prefer"),
        placeholder: this.$t("SetMenu.inputPrefer")
      },
      {
        name: this.$t("SetMenu.cook"),
        placeholder: this.$t("SetMenu.inputCookName")
      },
      {
        name: this.$t("SetMenu.package"),
        placeholder: this.$t("SetMenu.inputPackageName")
      },
      {
        name: this.$t("SetMenu.show"),
        placeholder: ""
      }
    ];
    this.searchMenuList = new Array(4);
  },
  mounted: function() {
    this.getTags();
    setTimeout(() => {
      this.getPerfers();
    }, 1000);
    setTimeout(() => {
      this.getDishs();
    }, 1500);
    setTimeout(() => {
      this.getPackages();
    }, 2000);
    this.getTagItem();
  },
  methods: {
    // 显示删除界面
    delShow() {
      this.isCheckboxesShow =
        this.isCheckboxesShow == "block" ? "none" : "block";
      this.batchType = "";
      this.functionShow = "none";
    },
    changeCompany(name) {
      this.batchType = name;
      this.show = true;
    },
    // 取消
    backBtn() {
      this.batchType = "";
      this.functionShow = "none";
    },
    // 批量绑定分类
    okBtn(type) {
      let data = {};
      if (type == 1) {
        data = {
          menu_id: this.tabsResult, // 产品id
          tags_id: this.tagResult, // 分类id
          type: type
        };
      } else {
        data = {
          menu_id: this.tabsResult, // 产品id
          tags_id: this.perResult, // 分类id
          type: type
        };
      }
      this.$axios({
        method: "patch",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/menu/batch",
        data: data
      })
        .then(res => {
          console.log("批量绑定", res);
          // this.functionShow = "none";
          this.show = false;
          this.tabsResult = [];
          this.result = [];
          this.$toast({
            type: "success",
            message: res.message
          });
        })
        .catch(err => {
          console.log(err);
          // this.$toast({
          //   type: "fail",
          //   message: this.$t("ShopList.message")
          // });
        });
    },
    editAmount() {
      this.$axios({
        method: "patch",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/menu/amount",
        data: {
          menu_id: this.tabsResult, // 产品id
          price: this.batchPrice // 修改金额
        }
      })
        .then(res => {
          console.log("批量绑定", res);
          this.show = false;
          this.tabsResult = [];
          this.batchPrice = [];
          this.$toast({
            type: "success",
            message: res.message
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    // 编辑
    editBtn(tab) {
      if (this.actTab == 0) {
        this.$router.push("/TagMenu/" + tab.id);
      } else if (this.actTab == 1) {
        sessionStorage.setItem("PerferName", tab.name);
        this.$router.push("/SetPerfer/" + tab.id);
      } else if (this.actTab == 2) {
        this.$router.push("/EditDish/" + tab.id);
      } else if (this.actTab == 3) {
        this.$router.push("/EditPackage/" + tab.id);
      }
    },
    // 复制
    copyBtn(tab) {
      let url = "";
      if (this.actTab == 0) {
        url = `/api/tags/${tab.id}/copy`;
      } else if (this.actTab == 1) {
        this.$toast({
          type: "",
          message: "None function"
        });
        return false;
      } else if (this.actTab == 2) {
        url = `/api/menu/${tab.id}/copy`;
      } else if (this.actTab == 3) {
        url = `/api/menu/${tab.id}/copy`;
      }
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + url
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            this.getTags();
            this.getPerfers();
            this.getDishs();
            this.getPackages();
            this.getTagItem();
          } else {
            this.$toast({
              type: "fail",
              message: res.data.message
            });
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopList.message")
          });
        });
    },
    // 切换标签
    tabChange() {
      this.content = [];
      this.searchMenuList[this.actTab] = this.searchMenu;
      this.searchMenu = this.searchMenuList[this.actTab];
      if (this.actTab == 0) {
        this.content = this.tags;
        this.tabsResult = this.tagsResult;
      } else if (this.actTab == 1) {
        this.content = this.perfers;
        this.tabsResult = this.perferResult;
      } else if (this.actTab == 2) {
        this.content = this.dishs;
        this.tabsResult = this.dishResult;
      } else if (this.actTab == 3) {
        this.content = this.packages;
        this.tabsResult = this.packagesResult;
      }
    },
    // 实时存储各个标签内选择的删除项
    tabsChange() {
      if (this.actTab == 0) {
        this.tagsResult = this.tabsResult;
      } else if (this.actTab == 1) {
        this.perferResult = this.tabsResult;
      } else if (this.actTab == 2) {
        this.dishResult = this.tabsResult;
      } else if (this.actTab == 3) {
        this.packagesResult = this.tabsResult;
      }
      if (!this.tabsResult) {
        this.tabsResult = [];
      }
    },
    // 搜索菜品
    onSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let val = "";
        val = this.searchMenu;
        if (val.trim()) {
          // 获取菜单
          this.$axios({
            method: "post",
            headers: {
              Authorization: "Bearer " + sessionStorage.token
            },
            url:
              this.$build + `/api/store/${sessionStorage.actShopId}/searchMenu`,
            data: {
              name: val,
              subscript: this.actTab // 下标：【0：分类，1：偏好，2：菜品，3：套餐】
            }
          })
            .then(res => {
              console.log("???", res);
              if (res.data.status == 200) {
                if (this.actTab == 0) {
                  this.tags = res.data.data;
                  this.tags.forEach(item => {
                    if (item.status == 0) {
                      item.status = false;
                    } else {
                      item.status = true;
                    }
                  });
                } else if (this.actTab == 1) {
                  this.perfers = res.data.data;
                  this.perfers.forEach(item => {
                    item.is_choiced = item.is_choiced == 1 ? true : false;
                  });
                } else if (this.actTab == 2) {
                  this.dishs = res.data.data;
                } else if (this.actTab == 3) {
                  this.packages = res.data.data;
                }
                this.tabChange();
              } else {
                for (var item in res.data.error) {
                  this.$toast({
                    type: "fail",
                    message: res.data.error[item]
                  });
                }
              }
            })
            .catch(err => {
              this.$toast({
                type: "fail",
                message: this.$t("ShopList.message")
              });
            });
        } else {
          this.getTags();
          this.getPerfers();
          this.getDishs();
          this.getPackages();
        }
      }, 1000);
    },
    // 添加
    addShow() {
      this.isCheckboxesShow = "none";
      switch (this.actTab) {
        case 0:
          this.addTag();
          break;
        case 1:
          this.addPerfer();
          break;
        case 2:
          this.addDish();
          break;
        default:
          this.addPackage();
          break;
      }
    },
    // 添加分类
    addTag() {
      this.newTag.name = "";
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/tags/store",
        data: {
          pid: 0,
          store_id: sessionStorage.actShopId,
          name: this.newTag.name,
          category: "class"
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            // this.$toast({
            // 	type:'success',
            // 	message:res.data.message,
            // });
            this.isAddTagShow = false;
            this.newTag.name = "";
            this.getTags();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("SetMenu.message")
          });
        });
    },
    // 添加偏好
    addPerfer() {
      this.newPerfer.name = "";
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/tags/store",
        data: {
          pid: 0,
          store_id: sessionStorage.actShopId,
          name: this.newPerfer.name,
          category: "perfer"
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            // this.$toast({
            // 	type:'success',
            // 	message:res.data.message,
            // });
            this.newPerfer.name = "";
            this.getPerfers();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("SetMenu.message")
          });
        });
    },
    // 添加产品
    addDish() {
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/menu/store",
        data: {
          store_id: sessionStorage.actShopId,
          level: 0,
          type: "o",
          category: "m",
          introduction: null
        }
      })
        .then(res => {
          console.log(">>>>>>>>", res);
          if (res.data.status == 200) {
            // this.$toast({
            // 	type:'success',
            // 	message:res.data.message,
            // });
            this.newDish.name = "";
            this.getDishs();
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("SetMenu.message")
          });
        });
    },
    // 添加套餐
    addPackage() {
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/menu/store",
        data: {
          level: 0,
          store_id: sessionStorage.actShopId,
          type: "o",
          category: "p",
          introduction: null
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            // this.$toast({
            // 	type:'success',
            // 	message:res.data.message,
            // });
            this.newPack.name = "";
            this.getPackages();
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("SetMenu.message")
          });
        });
    },
    // 全选
    selectAll() {
      switch (this.actTab) {
        case 0:
          if (this.tagsResult.length != this.tags.length) {
            this.tagsResult = [];
            for (var i = this.tags.length - 1; i >= 0; i--) {
              this.tagsResult.push(this.tags[i].id);
            }
          } else {
            this.tagsResult = [];
          }
          this.tabsResult = this.tagsResult;
          break;
        case 1:
          if (this.perferResult.length != this.perfers.length) {
            this.perferResult = [];
            for (var i = this.perfers.length - 1; i >= 0; i--) {
              this.perferResult.push(this.perfers[i].id);
            }
          } else {
            this.perferResult = [];
          }
          this.tabsResult = this.perferResult;
          break;
        case 2:
          if (this.dishsResult.length != this.dishs.length) {
            this.dishsResult = [];
            for (var i = this.dishs.length - 1; i >= 0; i--) {
              this.dishsResult.push(this.dishs[i].id);
            }
          } else {
            this.dishsResult = [];
          }
          this.tabsResult = this.dishsResult;
          break;
        default:
          if (this.packagesResult.length != this.packages.length) {
            this.packagesResult = [];
            for (var i = this.packages.length - 1; i >= 0; i--) {
              this.packagesResult.push(this.packages[i].id);
            }
          } else {
            this.packagesResult = [];
          }
          this.tabsResult = this.packagesResult;
          break;
      }
    },
    // 删除
    del() {
      switch (this.actTab) {
        case 0:
          this.delTag();
          break;
        case 1:
          this.delPerfer();
          break;
        case 2:
          this.delDishs();
          break;
        default:
          this.delPackages();
          break;
      }
    },
    // 删除分类
    delTag() {
      if (this.tabsResult.length > 0) {
        this.$dialog
          .confirm({
            title: this.$t("SetMenu.delCategory"),
            message: this.$t("SetMenu.isDelchooseCategory"),
            confirmButtonColor: "#2f75f4",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "DELETE",
              headers: {
                Authorization: "Bearer " + sessionStorage.token
              },
              url: this.$build + "/api/tags/destroy",
              data: {
                ids: JSON.stringify(this.tabsResult)
              }
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  this.$toast({
                    type: "success",
                    message: res.data.message
                  });
                  this.tagsResult = [];
                  this.isCheckboxesShow = false;
                  this.getTags();
                } else {
                  for (var item in res.data.error) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("SetMenu.message")
                });
              });
          })
          .catch(() => {});
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("SetMenu.chooseDelCategory")
        });
      }
    },
    // 删除偏好
    delPerfer() {
      if (this.perferResult.length > 0) {
        this.$dialog
          .confirm({
            title: this.$t("SetMenu.del"),
            message: this.$t("SetMenu.isDel"),
            confirmButtonColor: "#2f75f4",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "DELETE",
              headers: {
                Authorization: "Bearer " + sessionStorage.token
              },
              url: this.$build + "/api/tags/destroy",
              data: {
                ids: JSON.stringify(this.perferResult)
              }
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  this.$toast({
                    type: "success",
                    message: res.data.message
                  });
                  this.perferResult = [];
                  this.isCheckboxesShow = "none";
                  this.getPerfers();
                } else {
                  for (var item in res.data.error) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("SetMenu.message")
                });
              });
          })
          .catch(() => {});
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("SetMenu.chooseDelCategory")
        });
      }
    },
    // 删除产品
    delDishs() {
      if (this.tabsResult.length > 0) {
        this.$dialog
          .confirm({
            title: this.$t("SetMenu.delCook"),
            message: this.$t("SetMenu.isDelCook"),
            confirmButtonColor: "#2f75f4",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "DELETE",
              headers: {
                Authorization: "Bearer " + sessionStorage.token
              },
              url: this.$build + "/api/menu/destroy",
              data: {
                ids: JSON.stringify(this.tabsResult)
              }
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  this.$toast({
                    type: "success",
                    message: res.data.message
                  });
                  this.dishsResult = [];
                  this.isCheckboxesShow = "none";
                  this.getDishs();
                } else {
                  for (var item in res.data.error) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("SetMenu.message")
                });
              });
          })
          .catch(() => {});
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("SetMenu.chooseDelCategory")
        });
      }
    },
    // 删除套餐
    delPackages() {
      if (this.tabsResult.length > 0) {
        this.$dialog
          .confirm({
            title: this.$t("SetMenu.delPackage"),
            message: this.$t("SetMenu.isDelPackage"),
            confirmButtonColor: "#2f75f4",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "DELETE",
              headers: {
                Authorization: "Bearer " + sessionStorage.token
              },
              url: this.$build + "/api/menu/destroy",
              data: {
                ids: JSON.stringify(this.tabsResult)
              }
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  this.$toast({
                    type: "success",
                    message: res.data.message
                  });
                  this.packagesResult = [];
                  this.isCheckboxesShow = "none";
                  this.getPackages();
                } else {
                  for (var item in res.data.error) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("SetMenu.message")
                });
              });
          })
          .catch(() => {});
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("SetMenu.chooseDelCategory")
        });
      }
    },
    // 获取分类
    getTags() {
      // 获取
      // this.loading = true;
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build +
          "/api/tags/" +
          sessionStorage.actShopId +
          "/index/0/class"
      })
        .then(res => {
          // this.loading = false;
          console.log(res, "分类");
          if (res.data.status == 200) {
            // this.tags = res.data.data;
            this.tags = res.data.data;
            this.tags.forEach(item => {
              if (item.status == 0) {
                item.status = false;
              } else {
                item.status = true;
              }
            });
            this.tabChange();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("SetMenu.message")
          });
        });
    },
    // 获取偏好
    getPerfers() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build +
          "/api/tags/" +
          sessionStorage.actShopId +
          "/index/0/perfer"
      })
        .then(res => {
          console.log(res, "偏好");
          if (res.data.status == 200) {
            this.perfers = res.data.data;
            this.perfers.forEach(item => {
              item.is_choiced = item.is_choiced == 1 ? true : false;
            });
            this.tabChange();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("SetMenu.message")
          });
        });
    },
    // 获取产品
    getDishs() {
      // 获取
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/store/" + sessionStorage.actShopId + "/menus"
      })
        .then(res => {
          console.log(res, "菜品");
          if (res.data.status == 200) {
            this.dishs = res.data.data;
            this.tabChange();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("SetMenu.message")
          });
        });
    },
    // 获取套餐
    getPackages() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build +
          "/api/store/" +
          sessionStorage.actShopId +
          "/packages/all"
      })
        .then(res => {
          console.log(res, "套餐");
          if (res.data.status == 200) {
            this.packages = res.data.data;
            this.tabChange();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("SetMenu.message")
          });
        });
    },
    // 恢复选择的标签所在位置
    getTagItem() {
      if (sessionStorage.getItem("tabItem")) {
        this.actTab = Number(sessionStorage.getItem("tabItem"));
        if (Number(sessionStorage.getItem("tabItem")) == 4) {
          this.actTab = 0;
        }
      } else {
        this.actTab = 0;
      }
      if (this.actTab == 0) {
        this.content = this.tags;
      } else if (this.actTab == 1) {
        this.content = this.perfers;
      } else if (this.actTab == 2) {
        this.content = this.dishs;
      } else if (this.actTab == 3) {
        this.content = this.packages;
      }
      console.log(this.actTab);
    },
    handBtn(index) {
      if (this.actTab == 0) {
        this.handleCategory(index);
      } else if (this.actTab == 1) {
        this.handlePrefer(index);
      } else if (this.actTab == 2) {
        this.handleCook(index);
      } else if (this.actTab == 3) {
        this.handlePackage(index);
      }
    },
    showBtn(index) {
      if (this.actTab == 0) {
        this.showTagBtn(index);
      } else if (this.actTab == 1) {
        this.showPerferBtn(index);
      } else if (this.actTab == 2) {
        this.showDishBtn(index);
      } else if (this.actTab == 3) {
        this.showPackBtn(index);
      }
    },
    hideBtn(index) {
      if (this.actTab == 0) {
        this.hideTagBtn(index);
      } else if (this.actTab == 1) {
        this.hidePerferBtn(index);
      } else if (this.actTab == 2) {
        this.hideDishBtn(index);
      } else if (this.actTab == 3) {
        this.hidePackBtn(index);
      }
    },
    //输入分类 保存
    handleCategory(index) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.patchTag(index);
      }, 200);
    },
    //保存分類信息
    patchTag(index) {
      this.hideTagBtn(-1);
      if (this.tags[index].name) {
        this.$axios({
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url: this.$build + "/api/tags/" + this.tags[index].id + "/update",
          data: this.tags[index],
          withCredentials: true,
          crossDomain: true
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message
              });
              this.getTags();
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("SetMenu.message")
            });
          });
      } else {
        this.$toast(this.$t("SetMenu.toast"));
      }
    },
    showTagBtn(index) {
      this.actTagBtn = index;
      // console.log('showTagBtn'+index)
    },
    hideTagBtn(index) {
      const vm = this;
      // console.log('actTagBtn'+this.actTagBtn)
      setTimeout(function() {
        // console.log('hideTagBtn'+index)
        if (index == vm.actTagBtn || index == -1) {
          vm.actTagBtn = -1;
        }
      }, 60);
    },
    // 保存偏好
    handlePrefer(index) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.patchPerfer(index);
      }, 200);
    },
    showPerferBtn(index) {
      this.actPerferBtn = index;
      // console.log('showTagBtn'+index)
    },
    hidePerferBtn(index) {
      const vm = this;
      // console.log('actTagBtn'+this.actTagBtn)
      setTimeout(function() {
        // console.log('hideTagBtn'+index)
        if (index == vm.actPerferBtn || index == -1) {
          vm.actPerferBtn = -1;
        }
      }, 60);
    },
    // 保存偏好
    patchPerfer(index) {
      this.hidePerferBtn(-1);
      if (this.perfers[index].name) {
        this.$axios({
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url: this.$build + "/api/tags/" + this.perfers[index].id + "/update",
          data: this.perfers[index],
          withCredentials: true,
          crossDomain: true
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message
              });
              this.getPerfers();
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("SetMenu.message")
            });
          });
      } else {
        this.$toast(this.$t("SetMenu.toast"));
      }
    },
    // 保存菜品
    handleCook(index) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.patchDish(index);
      }, 200);
    },
    showDishBtn(index) {
      this.actDishBtn = index;
      // console.log('showTagBtn'+index)
    },
    hideDishBtn(index) {
      const vm = this;
      // console.log('actTagBtn'+this.actTagBtn)
      setTimeout(function() {
        // console.log('hideTagBtn'+index)
        if (index == vm.actDishBtn || index == -1) {
          vm.actDishBtn = -1;
        }
      }, 60);
    },
    // 保存菜品
    patchDish(index) {
      this.hideDishBtn(-1);
      if (this.dishs[index].name) {
        this.$axios({
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url: this.$build + "/api/menu/" + this.dishs[index].id + "/edit",
          data: this.dishs[index]
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message
              });
              this.getDishs();
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("SetMenu.message")
            });
          });
      } else {
        this.$toast(this.$t("SetMenu.toast"));
      }
    },
    // 保存套餐
    handlePackage(index) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.patchPackage(index);
      }, 200);
    },
    showPackBtn(index) {
      this.actPackBtn = index;
    },
    hidePackBtn(index) {
      const vm = this;
      setTimeout(function() {
        if (index == vm.actPackBtn || index == -1) {
          vm.actPackBtn = -1;
        }
      }, 60);
    },
    //保存套餐
    patchPackage(index) {
      this.hidePackBtn(-1);
      if (this.packages[index].name) {
        this.$axios({
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url: this.$build + "/api/menu/" + this.packages[index].id + "/update",
          data: this.packages[index]
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message
              });
              this.getPackages();
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("SetMenu.message")
            });
          });
      } else {
        this.$toast(this.$t("SetMenu.toast"));
      }
    },
    // 拖拽排序
    onStart(e) {
      this.drag = true;
      console.log(e, "开始");
    },
    onEnd(e) {
      this.disabled = true;
      if (this.startItem.category == "class") {
        this.data = {
          id: this.startItem.id,
          ids: this.endItem.id
        };
      } else if (this.startItem.category == "perfer") {
        this.data = {
          id: this.startItem.id,
          ids: this.endItem.id
        };
      } else {
        this.data = {
          pivot_id: this.startItem.id,
          pivot_ids: this.endItem.id
        };
      }
      this.Sort(this.startItem);
    },
    onMove(e, originalEvent) {
      //拖拽位置
      this.startItem = e.draggedContext.element;
      //停靠位置
      this.endItem = e.relatedContext.element;
      if (e.draggedContext.element) return false;
    },
    Sort(value) {
      let url = "";
      console.log(value);
      if (value.category == "class") {
        url = this.$build + "/api/tags/order";
      } else if (value.category == "perfer") {
        url = this.$build + "/api/tags/order";
      } else {
        url = this.$build + "/api/menu/allUpDown";
      }
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: url,
        data: this.data
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            if (this.actTab == 0) {
              this.getTags();
            } else if (this.actTab == 1) {
              this.getPerfers();
            } else if (this.actTab == 2) {
              this.getDishs();
            } else if (this.actTab == 3) {
              this.getPackages();
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast.clear();
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    // 开关
    Switch(item) {
      if (this.actTab == 0) {
        this.tagSwitch(item);
      } else if (this.actTab == 1) {
        this.perferSwitch(item);
      }
    },
    // 偏好多选开关
    perferSwitch(item) {
      let is_choiced, data;
      is_choiced = item.is_choiced == true ? 0 : 1;
      data = {
        id: item.id,
        is_choiced: is_choiced
      };
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/tags/multiple",
        data: data
      })
        .then(res => {
          console.log(res);
          this.$toast({
            type: "success",
            message: res.data.message
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 标签显示隐藏开关
    tagSwitch(item) {
      let status = "";
      if (item.status == true) {
        status = 0;
      } else {
        status = 1;
      }
      let data = {
        name: item.name,
        category: "class",
        status: status
      };
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/tags/" + item.id + "/update",
        data: data
      })
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 预览排序
    goDish(name, title) {
      sessionStorage.setItem("tabItem", this.actTab);
      // this.$toast(title);
      if (title == this.$t("SetMenu.show")) {
        this.$router.push("/Dishes");
      }
    },
    // 提示
    dragToast() {
      if (this.actTab == 2 || this.actTab == 3) {
        this.$toast({
          type: "text",
          message: "暂无拖拽功能"
        });
      }
    }
  }
};
</script>
<style scoped>
@media screen and (min-width: 800px) {
  /deep/ .van-sticky--fixed {
    width: 800px !important;
  }
}
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-tabs__line {
  background-color: #e93b3b;
}
/deep/ .van-cell__left-icon {
  font-size: 25px;
}
/deep/ .van-tab {
  font-size: 13px;
}
/deep/ .van-icon {
  font-size: 25px;
}
/deep/ .van-cell {
  align-items: center;
}
/deep/ .van-cell__value > span {
  padding-left: 10px;
}
/deep/ .van-checkbox-group {
  padding-bottom: 55px;
}
/deep/ .van-field__right-icon {
  width: auto;
  display: inline-flex;
  position: relative;
}
/deep/ .van-search__content {
  border: 1px solid #bfbfbf;
  background-color: #fff;
}
/deep/ .van-switch {
  margin: 0rem 0.9375rem;
}
/deep/ .van-field__left-icon {
  margin-right: 0.9375rem;
}
/deep/ .van-checkbox {
  position: relative;
  top: 0.625rem;
}
/deep/ .van-nav-bar__right {
  background-color: transparent !important;
}
/deep/ .van-loading {
  left: 50%;
  top: 6.25rem;
}
/deep/ .transition-wrapper .van-field__control {
  margin-left: 0.625rem;
}
.flexBox {
  display: flex;
  gap: 20px;
}
.flexBox /deep/ .van-button {
  height: 40px;
}
.mbottom {
  margin-bottom: 10px;
}
.home {
  width: 100%;
}
.editBtn {
  position: relative;
}
.tagInput {
  font-size: 14px;
  text-indent: 10px;
  width: 90%;
  height: 33px;
  line-height: 33px;
  border: 2px solid #ffb80f;
  margin-left: 5%;
  border-radius: 5px;
}
.bottomBtn {
  width: 30px;
  height: 30px;
  margin: 10px 20px;
}
.tagSort {
  /* width: 86px; */
  display: flex;
  justify-content: space-around;
}
.sort-move {
  transition: transform 0.3s;
}
.rightBtn {
  position: relative;
  height: 2.1875rem;
}
.title {
  height: 1.875rem;
  background: #fff;
}
.title div {
  display: inline-block;
}
.title span {
  display: inline-block;
}
.mleft {
  margin-left: 0.9375rem;
}
.right-name {
  float: right;
}
.edit {
  width: 10rem;
  text-align: center;
}
.swtichName {
  width: 3.75rem;
  text-align: center;
}
.function {
  padding: 10px;
  background: #fff;
}
.functionBox {
  background: #fff;
  padding: 20px;
}
.functionFooter {
  margin-top: 10px;
  text-align: right;
}
h3 {
  margin-top: 0;
}
.functionBox span {
  display: flex;
  align-items: center;
  line-height: 30px;
  margin: 0px 10px;
}
.functionBox /deep/ .van-checkbox {
  top: 0px;
  margin-right: 10px;
}
.functionBox /deep/ .van-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-bottom: 10px;
}
.transition-wrapper /deep/ .van-checkbox {
  top: 0;
}
.functionBtn {
  margin-right: 10px;
}
.dragIcon {
  cursor: move;
}
</style>



// WEBPACK FOOTER //
// src/Shop/SetMenu.vue